import WasmController from "react-lib/frameworks/WasmController";

// Utils
import { convertBEDateToADDashDate } from "react-lib/utils/dateUtils";
import moment from "moment";

// APIS
import ChatChannelNoSubscriptionList from "issara-sdk/apis/ChatChannelNoSubscriptionList_apps_MSG";
import UserChatSubscriptionList from "issara-sdk/apis/UserChatSubscriptionList_apps_MSG";
import ChatChannelList from "issara-sdk/apis/ChatChannelList_apps_MSG";
import UserChatSubscriptionDetail from "issara-sdk/apis/UserChatSubscriptionDetail_apps_MSG";
import KickUserChatChannelDetail from "issara-sdk/apis/KickUserChatChannelDetail_apps_MSG";
import ChatChannelDetail from "issara-sdk/apis/ChatChannelDetail_apps_MSG";
import MessageSearchView from "issara-sdk/apis/MessageSearchView_apps_MSG";
import EncounterDetail from "issara-sdk/apis/EncounterDetail_core";
import PatientQueueList from "issara-sdk/apis/PatientQueueList_apps_PRX";
import PatientDetailView from "issara-sdk/apis/PatientDetailView_apps_REG";
import PatientAppointmentView from "issara-sdk/apis/PatientAppointmentView_apps_QUE";
import DiagFormList from "issara-sdk/apis/DiagFormList_apps_PRX";
import ProxyPatientDetail from "issara-sdk/apis/ProxyPatientDetail_apps_PRX";
import PatientNoteListView from "issara-sdk/apis/PatientNoteListView_apps_REG";
import PatientNoteDetailView from "issara-sdk/apis/PatientNoteDetailView_apps_REG";
import PatientAppointmentUpdate from "issara-sdk/apis/PatientAppointmentUpdate_apps_QUE";
import DiagRuleList from "issara-sdk/apis/DiagRuleList_apps_PRX";
import FormCategoryList from "issara-sdk/apis/FormCategoryList_apps_PRX";
import CheckCanUseMeHealthServiceView from "issara-sdk/apis/CheckCanUseMeHealthServiceView_apps_MEH";
import ChatbotList from "issara-sdk/apis/ChatbotList_core"; 

// Serializers
import PatientAppointmentSerializer from "issara-sdk/types/PatientAppointmentSerializer_apps_QUE";
import DiagFormSerializer from "issara-sdk/types/DiagFormSerializer_apps_PRX";
import ProxyPatientSerializer from 'issara-sdk/types/ProxyPatientSerializer_apps_PRX'
import PatientNoteSerializer from "issara-sdk/types/PatientNoteSerializer_apps_REG";
import DiagRuleSerializer from "issara-sdk/types/DiagRuleSerializer_apps_PRX";
import FormCategorySerializer from "issara-sdk/types/FormCategorySerializer_apps_PRX";
import ChatbotSerializer from "issara-sdk/types/ChatbotSerializer_core"




export type Props = {};

export type State = {
  // common state
  errorMessage?: any;
  django?: any;
  currentDoctor?: any;
  chatRoomList?: any[];
  allChatRoomList?: number[];
  allAdminChatRoomIds?: number[];
  allAdminChatRoomList?: any[];
  adminChatUnreadCount?: string;
  patientHNChatList?: string[];
  userChatSubscriptionList?: any[];
  showIconNoti?: boolean;
  goToStaffChat?: boolean;
  searchMessageList?: Record<string, any>;
  modOpenLinkEncounter?: string;
  selectedPatientChat?: Record<string, any> | null;
  selectedPatientAppointmentList?: PatientAppointmentSerializer[];
  selectedPatientDiagFormList?: DiagFormSerializer[];
  selectedPatientNoteList?: PatientNoteSerializer[];
  selectedProxyPatient?: ProxyPatientSerializer;
  diagFormData: DiagFormData;
  aiBotLists?: { divisionId: number, aiLists: ChatbotSerializer[]} 
};

export type DiagFormData = Partial<{
  searchLoading: boolean;
  activePage: number;
  items: DiagFormSerializer[];
  total: number;
  diagFormList: DiagRuleSerializer[];
}>;

export type DiagFormFilter = Partial<{
  form_type: "ALL" | "INPUT_FORM" | "DECISION_TREE";
  diag_rule: number | string;
  start_date: string; // YYYY-MM-DD (AD) Format Ex. 2025-12-19
  end_date: string; // YYYY-MM-DD (AD) Format Ex. 2025-12-20
  type?: string;
}>;

export const StateInitial: State = {
  chatRoomList: [],
  allChatRoomList: [],
  allAdminChatRoomList: [],
  searchMessageList: {},
  userChatSubscriptionList: [],
  goToStaffChat: false,
  selectedPatientChat: null,
  diagFormData: {},
};

export type Event =
  | {
      message: "GetChatChannelList";
      params: { isPatient: boolean; user: string; all?: boolean };
    }
  | {
      message: "GetUnreadMessageCountStaff";
      params: { isPatient?: boolean; user?: string; all?: boolean; isChatPatientOnly?: boolean };
    }
  | {
      message: "CreateUpdateChatRoom";
      params: { userIds: number[]; groupName: string };
    }
  | { message: "GetUserChatSubscriptionList"; params: { id: number } }
  | { message: "GetSearchMessageList"; params: { search: string } }
  | { message: "GetPatientChatDetail"; params: { patient: number } }
  | {
      message: "HandleOpenLinkEncounter";
      params: {
        type?: string;
        event?: MouseEvent;
        encounterId: string;
        href?: string;
        django?: any;
        replace?: string;
        doctorId?: number;
      };
    }
  | { message: "GetPatientAppointmentList"; params: { patient: number; division: number } }
  | { message: "GetPatientDiagFormList"; params: { patient: number; division: number;} }
  | { message: "GetPatientDiagFormFilter"; params: { patient: number; division: number; activePage: number; filter: DiagFormFilter; } }
  | { message: "GetProxyPatient"; params: { patient: number } }
  | { message: "GetPatientNoteList"; params: { patient: number } }
  | { message: "SavePatientNote"; params: { patient: number; note: string } }
  | { message: "UpdatePatientNote"; params: { id: number; patient: number; note: string } }
  | { message: "DeletePatientNote"; params: { id: number; patient: number } }
  | { message: "GetPatientAppointmentDetail"; params: { id: number } }
  | { message: "GetDiagFormList"; params: { division: number } }
  | { message: "GetFormCategoryList"; params: { division: number } }
  | { message: "GetUsableAIList"; params: { division: number } };

export type Data = {
  division?: number;
  device?: number;
};

export const DataInitial = {};

type Handler = (controller: WasmController<State, Event, Data, Props>, params?: any) => any;

const formatMembers: Handler = async (
  controller,
  params: {
    channelId: number | string;
    chatRoomList: any[];
    isChatPatientOnly?: boolean;
    items: any[];
  }
) => {
  let { items } = params;

  if (params.channelId === "all") {
    let response: any[] = [];

    if (!params.isChatPatientOnly) {
      let promiseArr: any[] = [];

      promiseArr = items
        .map((item: any) => item.chat_channel_id)
        .map((id) =>
          UserChatSubscriptionList.list({
            apiToken: controller.apiToken,
            params: { chat_channel_id: id },
          })
        );

      response = await Promise.all(promiseArr);
    }

    items = items.map((item, index) => ({
      ...item,
      chat_channel_name_autogen:
        item.member_count === 1 ? "ห้องว่าง" : item.chat_channel_name_autogen,
      name: item.member_count === 1 ? "" : item.name,
      members: response[index]?.[0]?.items || [],
    }));
  } else if (params.channelId) {
    let member: any = {};

    if (!params.isChatPatientOnly) {
      [member] = await UserChatSubscriptionList.list({
        apiToken: controller.apiToken,
        params: { chat_channel_id: params.channelId },
      });
    }

    items = items.map((item, index) => ({
      ...item,
      chat_channel_name_autogen:
        item.member_count === 1 ? "ห้องว่าง" : item.chat_channel_name_autogen,
      name: item.member_count === 1 ? "" : item.name,
      members:
        params.channelId === item.chat_channel_id
          ? member?.items || []
          : (params.chatRoomList || []).find((acc) => item.chat_channel_id === acc.chat_channel_id)
              ?.members || [],
    }));
  }

  return items;
};

export const GetChatChannelList: Handler = async (controller, params) => {
  const state = controller.getState();

  const chatList = params.isChatPatientOnly
    ? await PatientQueueList.list({
        apiToken: controller.apiToken,
        params: {
          division: controller.data.division,
          search: params.search,
          signed_Only: true,
          unsigned_Only: true,
          unread_only: params.unread_only
        },
      })
    : await ChatChannelNoSubscriptionList.list({
        apiToken: controller.apiToken,
        params: {
          employee_only: true,
          search: params.search,
        },
      });

  let items: any[] = (chatList[0]?.items || [])
    .map((item: any) => ({
      ...item,
      chat_channel_id: item.chat_channel_id || item.chat_channel,
      chat_channel_name_autogen: item.chat_channel_name_autogen || item.patient_name,
      latest_message_content: item.latest_message_content || item.latest_message,
    }))
    .filter((item) => (params.isChatPatientOnly ? true : item.division == null));

  let allItems = params.isChatPatientOnly
    ? state.allAdminChatRoomIds || []
    : state.allChatRoomList || [];

  if (!params.all) {
    items = await formatMembers(controller, {
      items,
      channelId: params.channelId,
      chatRoomList: state.chatRoomList || [],
      isChatPatientOnly: params.isChatPatientOnly,
    });
  } else {
    allItems = items.map((item: any) => item.chat_channel_id);
  }

  const isNewChat = allItems.find(
    (id) => params.channelId !== id && typeof params.channelId === "number"
  );

  if (isNewChat) {
    allItems = [Number(params.channelId), ...allItems];
  }

  const isUnread = GetUnreadMessageCount(controller, {
    chatList: items,
    chatRoomId: params.chatRoomId,
  });

  const totalUnreadCount = items.reduce(
    (result: number, item: any) => result + Number(item.unread_message_count),
    0
  );

  controller.setState(
    params.isChatPatientOnly
      ? {
          [params.all ? "allAdminChatRoomIds" : "chatRoomList"]: [...items],
          allAdminChatRoomIds: allItems,
          ...(params.all && { allAdminChatRoomList: [...items] }),
          showIconNoti: isUnread,
          adminChatUnreadCount: totalUnreadCount > 99 ? "99+" : String(totalUnreadCount || ""),
        }
      : {
          [params.all ? "allChatRoomList" : "chatRoomList"]: [...items],
          allChatRoomList: allItems,
          showIconNoti: isUnread,
        }
  );

  return items;
};

export const GetUnreadMessageCountStaff: Handler = async (controller, params) => {
  await GetChatChannelList(controller, params);
};

export const GetUserChatSubscriptionList: Handler = async (controller, params) => {
  if (!params.chat_channel_id) {
    return controller.setState({ userChatSubscriptionList: [] });
  }

  const chat = await UserChatSubscriptionList.list({
    apiToken: controller.apiToken,
    params,
  });

  controller.setState({
    userChatSubscriptionList: chat[0].items || [],
  });
};

export const CreateUpdateChatRoom: Handler = async (controller, params) => {
  if (params.type === "create") {
    let chat: any = [null, null, null];

    if (!params.notChangeName) {
      chat = await (params.chatChannelId ? ChatChannelDetail.update : ChatChannelList.create)({
        apiToken: controller.apiToken,
        pk: params.chatChannelId,
        data: {
          name: params.groupName,
          basic: "true",
        } as any,
        extra: {
          division: controller.data.division,
        },
      });
    }

    return (await params.userIds?.length)
      ? UserChatSubscriptionList.create({
          apiToken: controller.apiToken,
          data: {
            list_user_id: params.userIds,
            chat_channel_id: params.chatChannelId || chat[0].chat_channel_id,
            action: params.action,
            force: "true",
          } as any,
          extra: {
            division: controller.data.division,
          },
        })
      : [null, null, null];
  } else if (params.type === "delete") {
    // if (params.isChangeName) {
    //   await CreateUpdateChatRoom(controller, {
    //     ...params,
    //     type: "change_name",
    //   });
    // }

    return await KickUserChatChannelDetail.update({
      apiToken: controller.apiToken,
      pk: params.chatChannelId,
      data: {
        list_user_id: params.userIds,
        action: "KICK",
      } as any,
    });
  } else if (params.type === "leave") {
    // if (params.isChangeName) {
    //   await CreateUpdateChatRoom(controller, {
    //     ...params,
    //     type: "change_name",
    //   });
    // }

    return await UserChatSubscriptionDetail.update({
      apiToken: controller.apiToken,
      pk: params.userChatSubscriptionId,
      data: {
        action: "LEAVE",
      },
    });
  } else if (params.type === "change_name") {
    return await ChatChannelDetail.update({
      apiToken: controller.apiToken,
      pk: params.chatChannelId,
      data: {
        name: params.groupName,
        basic: "true",
      } as any,
      extra: {
        division: controller.data.division,
      },
    });
  }
};

const GetMessageSearch: Handler = (controller, params) => {
  return MessageSearchView.list({
    apiToken: controller.apiToken,
    chat_channel_id: params.chatChannelId,
    params: {
      search: params.search,
      offset: params.offset,
      last: params.last,
    },
  });
};

export const GetSearchMessageList: Handler = async (controller, params) => {
  if (params.clear) {
    return controller.setState({ searchMessageList: {} });
  }

  const state = controller.getState();

  let result: any = {};

  if (params.previous) {
    [result] = await controller.handleEvent({
      message: "getMessageFromURL",
      params: { apiToken: controller.apiToken, url: params.previous },
    } as any);
  } else {
    [result] = await GetMessageSearch(controller, params);
  }

  const item = Array.isArray(result?.items) ? { items: result.items, count: result.total } : {};

  if (item.items) {
    item.items = item.items.reverse();
  }

  if (params.concat) {
    item.items = [...(state.searchMessageList?.items || []), ...(item.items || [])];

    const key = "id";
    const arrayUniqueByKey: any[] = Array.from(
      new Map(item.items.map((item: any) => [item[key], item])).values()
    );

    item.items = arrayUniqueByKey;
  }

  controller.setState({ searchMessageList: { ...item, page: params.page } });
};

export const GetPatientChatDetail: Handler = async (controller, params) => {
  const [patient] = await PatientDetailView.retrieve({
    pk: params.patient,
    apiToken: controller.apiToken,
  });

  controller.setState({
    selectedPatientChat: patient,
  });
};

export const GetPatientAppointmentList: Handler = async (controller, params) => {
  const [appointments] = await PatientAppointmentView.list({
    apiToken: controller.apiToken,
    params: {
      patient_id: params.patient,
      division_id: params.division,
      limit: 9999, // *
    }
  });

  controller.setState({
    selectedPatientAppointmentList: appointments.items || [],
  });
};

// --- สำหรับเรียกหน้า Panel
export const GetPatientDiagFormList: Handler = async (controller, params) => {
  const [diagForms] = await DiagFormList.list({
    apiToken: controller.apiToken,
    params: {
      patient: params.patient,
      division: params.division,
      latest: true,
      limit: 9999, // *
    },
  });

  controller.setState({
    selectedPatientDiagFormList: diagForms.items || [],
  });
};

// --- สำหรับ Filter Form Action
export const GetPatientDiagFormFilter: Handler = async (controller, params) => {
  const LIST_LIMIT = 10;

  const activePage = params.activePage ?? 1;
  const offset = (activePage - 1) * LIST_LIMIT;

  const formattedFilter = formattedDiagFormFilter(params.filter);

  controller.setState(prev => ({
    diagFormData: {
      ...prev.diagFormData,
      searchLoading: true,
    }
  }));
  
  const [diagForms] = await DiagFormList.list({
    apiToken: controller.apiToken,
    params: {
      patient: params.patient,
      division: params.division,
      offset,
      ...formattedFilter,
      limit: LIST_LIMIT,
    },
    extra: { division: controller.data.division },
  });

  controller.setState(prev => ({
    diagFormData: {
      ...prev.diagFormData,
      searchLoading: false,
      activePage,
      items: diagForms?.items ?? [],
      total: diagForms?.total ?? 0,
    },
  }));
};

export const GetProxyPatient: Handler = async (controller, params) => {
  const [proxyPatient] = await ProxyPatientDetail.retrieve({
    apiToken: controller.apiToken,
    pk: params.patient,
    // params: {},
  });

  controller.setState({
    selectedProxyPatient: proxyPatient,
  });
};

export const GetPatientNoteList: Handler = async (controller, params) => {
  const [notes] = await PatientNoteListView.list({
    apiToken: controller.apiToken,
    params: {
      patient: params.patient,
      active: true,
    },
    extra: { division: controller.data.division },
  });

  controller.setState({
    selectedPatientNoteList: notes?.items || [],
  });
};

export const SavePatientNote: Handler = async (controller, params) => {
  const [saveNoteResp, saveNoteErr] = await PatientNoteListView.create({
    apiToken: controller.apiToken,
    data: {
      patient: params.patient,
      note: params.note,
    },
    extra: { division: controller.data.division },
  });

  if (saveNoteErr || !saveNoteResp) {
    controller.setState({
      errorMessage: {
        StaffChat: saveNoteErr,
      },
    });

    return;
  }

  const patient = saveNoteResp?.patient;

  // Update Patient Note List
  await GetPatientNoteList(controller, { patient });
};

export const UpdatePatientNote: Handler = async (controller, params) => {
  const [updateNoteResp, updateNoteErr] = await PatientNoteDetailView.update({
    apiToken: controller.apiToken,
    pk: params.id,
    data: {
      patient: params.patient,
      note: params.note,
    },
    extra: { division: controller.data.division },
  });

  if (updateNoteErr || !updateNoteResp) {
    controller.setState({
      errorMessage: {
        StaffChat: updateNoteErr,
      },
    });

    return;
  }

  // Update Patient Note List
  await GetPatientNoteList(controller, { patient: params.patient });
};

export const DeletePatientNote: Handler = async (controller, params) => {
  const [delNoteResp, delNoteErr, delNoteNet] = await PatientNoteDetailView.delete({
    apiToken: controller.apiToken,
    pk: params.id,
    extra: { division: controller.data.division },
  });

  if (delNoteErr || delNoteNet?.status !== 204) {
    controller.setState({
      errorMessage: {
        StaffChat: delNoteErr,
      },
    });

    return;
  }

  // Update Patient Note List
  await GetPatientNoteList(controller, { patient: params.patient });
};

export const GetDiagFormList: Handler = async (controller, params) => {
  const [diagFormResp, diagFormErr] = await DiagRuleList.list({
    apiToken: controller.apiToken,
    params: {
      division: params.division,
      active: true,
      limit: 9999, // *
    },
    extra: { division: controller.data.division },
  });

  if (diagFormErr || !diagFormResp?.items) return;

  controller.setState(prev => ({
    diagFormData: {
      ...prev.diagFormData,
      diagFormList: diagFormResp.items || [],
    },
  }));
};

export const GetFormCategoryList: Handler = async (controller, params) => {
  const [formCateResp, formCateErr] = await FormCategoryList.list({
    apiToken: controller.apiToken,
    params: {
      division: params.division,
      limit: 9999, // *
    },
    extra: { division: controller.data.division },
  });

  if (formCateErr || !formCateResp) return;

  controller.setState(prev => ({
    diagFormData: {
      ...prev.diagFormData,
      formCategoryList: formCateResp.items || [],
    },
  }));
};

export const GetUsableAIList: Handler = async (controller, params) => {
  const [aiBotLists, aiBotListsError] = await ChatbotList.list({
    apiToken: controller.apiToken,
    extra: { division: params.divisionId },
  });


  if (aiBotListsError || !aiBotLists)  {
     controller.setState({aiBotLists: {
      divisionId: params.divisionId,
      aiLists: [],
    }})
    return;
  }


  console.log('HandleCheckCanUseAndHaveService aiBotLists: ', aiBotLists);
  let aiLists: any[] = [];
  if (aiBotLists?.items?.length > 0 ) {
    aiLists = aiBotLists?.items
  }

  const resultCheckingList = await Promise.all(
    aiLists.map(async (aiItem) => {
      const checkResult = await CheckCanUseMeHealthServiceView.get({
        apiToken: controller.apiToken,
        params: {
          service_code: aiItem?.name,
          specific_datetime: moment().toISOString(),
        },
        extra: { division: params.divisionId },
      });
      return { name: aiItem?.name, result: checkResult };
    })
  );

   aiLists = aiLists.filter((ai: any, index: number) => {
    if (resultCheckingList[index].result?.[0]?.[ai.name]?.can_use) {
      return true
    }
    return false
  })

  controller.setState((prev) => ({
    aiBotLists: {
      divisionId: params.divisionId,
      aiLists: aiLists,
    },
  }));

};


const GetUnreadMessageCount: Handler = (controller, params) => {
  const sum = params.chatList
    .filter((item: any) => item.id !== params.chatRoomId)
    .reduce((result: number, item: any) => (result += item.unread_message_count || 0), 0);

  if (sum >= 1) {
    return true;
  } else {
    return false;
  }
};

export const HandleOpenLinkEncounter: Handler = async (
  controller,
  params: Extract<Event, { message: "HandleOpenLinkEncounter" }>["params"]
) => {
  const state = controller.getState();

  const e = params.event;
  const doctorId = params.doctorId || state.currentDoctor?.id;
  const clickLeft = e?.button === 0;
  const element = e?.target as HTMLAnchorElement | null;
  let loader = element?.querySelector(".ui.mini.active.loader") as HTMLAnchorElement | null;
  const isContext = params.type === "contextmenu";

  if (e && params.encounterId && !isContext) {
    e.preventDefault();
    e.stopPropagation();
  }

  if (isContext) {
    return loader?.remove();
  }

  if (loader) {
    return;
  }

  const django = params.django || controller.getState().django;

  if (params.encounterId) {
    element?.insertAdjacentHTML(
      "afterbegin",
      `<div class="ui mini active loader" style="left: -7px;"/>`
    );

    const result = await EncounterDetail.retrieve({
      apiToken: controller.apiToken,
      pk: params.encounterId,
    });

    const encounter = result[0] || {};

    if (encounter.id) {
      const isDoctor = django?.user?.role_types?.includes("DOCTOR");
      const isActive =
        (doctorId === encounter.student || doctorId === encounter.doctor) && isDoctor;
      // &&
      // encounter.is_expired === false;

      // #const isNotPermission = isDoctor && doctorId !== encounter.student && doctorId !== encounter.doctor;

      // console.log(isActive, params, encounter)

      if (isActive) {
        // if (encounter.status === "IN_EXAM") {
        //   if (params.href) {
        //     if (clickLeft){
        //       window.open(params.href, "_blank", "noopener noreferrer")?.focus();
        //     }
        //   }
        // } else
        if (["ARRIVING", "IN_QUEUE", "IN_EXAM", "CHECKED_OUT"].includes(encounter.status)) {
          if (params.href && clickLeft) {
            window.open(params.href, "_blank", "noopener noreferrer")?.focus();
          }
        } else if (clickLeft || params.replace) {
          controller.setState({
            modOpenLinkEncounter: `ไม่สามารถดำเนินการได้ เนื่องจากผู้ป่วย\n“${encounter.status_name}”`,
          });
        }
      } else if (clickLeft || params.replace) {
        controller.setState({
          modOpenLinkEncounter: "ไม่มีสิทธิในการดำเนินการ",
        });
      }

      loader = element?.querySelector(".ui.mini.active.loader") as HTMLAnchorElement | null;
      loader?.remove();

      return encounter;
    }
  }
};

export const GetPatientAppointmentDetail: Handler = async (controller, params) => {
  return PatientAppointmentUpdate.retrieve({
    apiToken: controller.apiToken,
    pk: params.id,
  });
};

// Utils
export const getAddressDetail = (state: Record<string, any> = {}) => {
  const type = state?.serviceLocationType || state?.extra?.service_location_type;
  const address = state?.location?.address || state?.extra?.address || {};
  const officialAccount = state?.officialAccount || state.extra?.official_account || {};

  if (type === "home") {
    return {
      name: address.name || "",
      address: address.full_address_text || "",
      image: "",
      type,
      latitude: address.latitude,
      longitude: address.longitude,
      icon: "/images/common/icon_home_solid_pink.png",
    };
  }

  const divisionName =
    officialAccount.division_name || officialAccount.name || state.division_name || "";
  const divisionAddress = officialAccount.address_text || state.division_location || "";

  return {
    name: divisionName,
    address: divisionAddress,
    image: officialAccount.image_file,
    type,
    icon: "/images/common/icon_building_regular_pink.png",
    city: officialAccount.city,
    district: officialAccount.district,
    province: officialAccount.province,
  };
};

const formattedDiagFormFilter = (filter: DiagFormFilter): DiagFormFilter => {
  const formattedStartDate = convertBEDateToADDashDate(filter?.start_date);
  const formattedEndDate = convertBEDateToADDashDate(filter?.end_date);

  return {
    ...(filter?.form_type !== "ALL" ? { form_type: filter.form_type } : {}),
    ...(filter?.diag_rule !== "ALL" ? { diag_rule: filter.diag_rule } : {}),
    start_date: formattedStartDate,
    end_date: formattedEndDate,
  };
};
